import * as React from 'react';
import { styled } from '@mui/material';
import { MuiModal } from 'ui/MuiModal';
import { AdjustmentSchemeEditStepper } from '../forms/AdjustmentSchemeEditStepper';
import { AdjustmentScheme } from '../adjustmentSchemeModel';

interface AdjustmentSchemeEditModalProps {
    open: boolean;
    currencySymbol: string;
    scheme: AdjustmentScheme;
    existingSchemes: AdjustmentScheme[];
    onClose: () => void;
    onSuccess: (scheme: AdjustmentScheme) => void;
}

const StyledMuiModal = styled(MuiModal)(({ theme }) => ({
    width: `calc(100% - ${theme.spacing(4)})`,
    maxWidth: theme.spacing(160)
}));

export const AdjustmentSchemeEditModal: React.FC<AdjustmentSchemeEditModalProps> = ({
    open,
    scheme,
    currencySymbol,
    existingSchemes,
    onClose,
    onSuccess
}) => (
    <StyledMuiModal open={open} onClose={onClose}>
        <AdjustmentSchemeEditStepper
            scheme={scheme}
            currencySymbol={currencySymbol}
            existingSchemes={existingSchemes}
            onSuccess={onSuccess}
            onClose={onClose}
        />
    </StyledMuiModal>
);
